import { createContext } from 'react';

export const MeterUpgradeProcessContext = createContext({});
